import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { matchPassword } from '@core/validators/auth.validator';

@Component({
  selector: 'prism-reset-password-form',
  templateUrl: './reset-password-form.component.html',
  styleUrl: './reset-password-form.component.scss'
})
export class ResetPasswordFormComponent implements OnInit {
  @Input() buttonLabel = 'Submit';
  @Input() showPopover = true;
  @Output() submitted = new EventEmitter<string>();

  form!: FormGroup | any;
  constructor(private fb: FormBuilder) {}

  get password()  { return this.form.get('password'); }
  get confirmPw() { return this.form.get('confirmPw'); }

  ngOnInit(): void {
    this.form = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(50)]],
      confirmPw: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(50)]],
    }, { validators: [matchPassword('password', 'confirmPw')] });
  }

  onSubmit(): void {
    if (this.form.valid) this.submitted.emit(this.password?.value);
  }
}
